import React from 'react';
import { map } from 'lodash';
import AbsoluteValue from '../../AbsoluteValue';
import { percentageValue } from '../../../../helpers/NumberFormatter';

export const devicesSettings = {
    settingsForTable,
    settingsForRow
};


function settingsForTable(mode){
    
    
    let columns = [
      {
              id: 'icon',
              headerClassName: 'table-header-item icon-header icon',
              className: 'icon', 
              Header: '',
              // width: 70,
              accessor: 'device',
              Cell: props => <div className="device-icon"></div>
          },
                                
       {
           id: 'device',
           className: 'imprint-name',
           headerClassName: 'imprint-name',
           Header: 'device',
           accessor: 'device',
           // width: 190
       },
       {
           id: 'streams',
           headerClassName: 'table-header-item streams-header',
           className: 'streams',
           Header: 'Streams',
           Cell: props => <AbsoluteValue value={props.value}></AbsoluteValue>,
           // width: 70,
           accessor: 'curr_units'
       },
       {
           id: 'share',
           headerClassName: 'table-header-item share',
           className: 'share',
           Header: 'Share',
           // width: 70,
           accessor: 'share',
           Cell: props => <span className="share-val">{props.value}%</span>,
       },
    ];
    return columns.map(column=>{
        //column.show = modes[mode].includes(column.id);
        return column;
    });
}

function settingsForRow(state, rowInfo, column) {
    if(rowInfo===undefined)
        return {};

    return {
        className: `tr-device tr-device-${rowInfo.row.device.toLowerCase()}`
    }
}